import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.scss';
import './Carousel.scss';
import { settings2 } from './settings2';

const Carousel: React.FC = props => {
  return (
    <div className="Carousel">
      <Slider {...settings2}>{props.children}</Slider>
    </div>
  );
};

export default Carousel;
